// @tailwind
import { Box, Button, Collapse, Fade, Slide } from "@mui/material";
import AppBar from "./AppBar";
import MenuDrawer, { MenuItem, MenuTitleListItem } from "@/layouts/ManagerLayout/MenuDrawer";
import React, { useState, useRef, useEffect } from "react";
import { Outlet, useParams, ScrollRestoration, useNavigation, useRevalidator, useLoaderData, } from "react-router-dom";
import {
    Info as InfoIcon,
    ProductionQuantityLimits as ProductIcon,
    ReceiptLong as OrderListIcon,
    LocalShipping as ShippingIcon,
    SupportAgent as VocIcon,
    SettingsOutlined as SettingIcon,
    Dashboard as TemplateIcon, NewReleases,
    Troubleshoot, RecommendOutlined
} from '@mui/icons-material';

import { env } from '@/constant/configure';

import Footer from "@/components/common/Footer";
import { useSessionStore } from "@/store";
import ScreenOperator from "@/components/common/ScreenOperator";
import PageLoadingScreen from "@/components/PageLoadingScreen";
import Banner from "@/layouts/components/Banner";
import { DialogContainer, dialogClear, dialogClose, dialogOpen } from "@/modules/MuiDialog";
import tempProductImg from '@/assets/images/character/pudding_viva.gif'

import vendorProductImg from '@/assets/images/sources/seller_vendor_product.png'
import myProductImg from '@/assets/images/sources/seller_my_product.png'
import sellerSalesImg from '@/assets/images/sources/seller_sales.png'
import MarketingTermsDialog from "@/components/MarketingTermsDialog";
import { postConfirmTerms } from "@/services/auth.service";

const AppendExample = () => (
    <Box sx={{
        backgroundColor: 'var(--v-palette-black-main)',
        color: 'var(--v-palette-black-contrastText)',
        px: 3,
        py: 2,
    }}>
        <Button href={'/about'} variant={'contained'} color={'white'} size={'small'} fullWidth sx={{ my: 1 }}>
            <div className={'flex justify-between w-full'}>
                <span><SettingIcon /></span>
                <span className={'grow text-center'}>사이드바 하단 예시</span>
            </div>
        </Button>
    </Box>
)

const PublicLayout = () => {
    const [appBarHeight, setAppBarHeight] = useState(64);
    const [drawWidth, setDrawWidth] = useState(240);
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [isBannerOpen, setIsBannerOpen] = useState(false);
    const drawRef = useRef<HTMLDivElement>(null);
    const params = useParams();

    const session = useSessionStore();
    const mallId = params.mallId || session.mallId || '';
    const userId = params.userId || session.userId || '';

    const { state } = useNavigation();

    const main_menu: MenuItem[] = [
        { label: '인트로', isActive: false, isShowDivider: true, to: `/sourcing/${userId || '-'}`, },
        { label: '신규 요청', isActive: false, isShowDivider: true, to: `/sourcing/${userId || '-'}/request-list`, },
    ];

    const menu_dev: MenuItem[] = [
        ...main_menu,
        {
            label: 'Template Demo',
            icon: <TemplateIcon />,
            isActive: false,
            children: [
                {
                    label: 'Typography',
                    to: '/template-demo',
                },
                {
                    label: 'Toast Editor',
                    to: '/template-demo/toast-editor',
                },
                {
                    label: 'Dialogs',
                    to: '/template-demo/dialog',
                },
                {
                    label: 'Buttons',
                    to: '/template-demo/button',
                },
                {
                    label: 'Custom Fields',
                    to: '/template-demo/custom-fields',
                },
                {
                    label: 'Drag and Drop',
                    to: '/template-demo/drag-and-drop',
                },
                {
                    label: 'Banner',
                    to: '/template-demo/banner-demo',
                },
            ],

        },
    ]

    const menuTitleList: MenuTitleListItem[] = [
        { menuTitle: 'HOME', menuTitleImg: tempProductImg, menuList: env === 'prd' ? main_menu : menu_dev },
    ]

    useEffect(() => {
        if (!!drawRef.current) {
            setDrawWidth(!!drawRef?.current ? drawRef?.current?.clientWidth : 0);
        }
    })

    return (
        <>
            <PageLoadingScreen isLoading={state === 'loading'} message="데이터를 불러오는 중..." />
            <Box className={'flex flex-col'} sx={{
                flexGrow: 1,
                display: 'flex',
                '--app-bar-height': `${appBarHeight}px`,
                scrollBehavior: 'smooth',
            }}>
                <AppBar isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} setAppBarHeight={setAppBarHeight} />
                <MenuDrawer
                    isDrawerOpen={isDrawerOpen}
                    appBarHeight={appBarHeight}
                    ref={drawRef}
                    menuTitleList={menuTitleList}
                // append={<AppendExample/>} 
                />
                <Box sx={(theme) => ({
                    flexGrow: 1,
                    // backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    // marginLeft: isDrawerOpen ? `${drawWidth}px` : 0,
                    transition: `margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms`,
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    zIndex: 0,

                    [theme.breakpoints.up('sm')]: {
                        marginLeft: isDrawerOpen ? `${drawWidth}px` : 0,
                    },
                })}>

                    <Banner isOpen={isBannerOpen} color={'warning'}
                        prepend={<NewReleases sx={{
                            fontSize: '45px',
                        }} />}
                        message={'현재 회원님은 관리자로부터 최종 승인이 되지 않았습니다.<br/>일부 기능의 사용이 제한될 수 있습니다.'}
                        isAllowHtml
                        closeText={'네, 확인했습니다'}
                        ButtonProps={{
                            variant: 'outlined',
                            color: 'black',
                        }}
                        appBarHeight={appBarHeight} sticky />

                    <Box component={'section'} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        // px: 3,
                        // py: 2,
                        flexGrow: 1,
                        position: 'relative',
                        zIndex: 0,
                    }}>
                        <Outlet />
                        <ScrollRestoration
                            getKey={(location, matches) => {
                                return location.key;
                            }}
                        />
                    </Box>
                    {/* <Footer component={'footer'} px={3} py={1} /> */}
                </Box>
            </Box>

            <DialogContainer />
        </>
    )
}

export default PublicLayout;